module.exports = __webpack_public_path__ + "img/20191008155753663.0af2bf2d.jpg";